import Entity from './entity'
export default class Gwequipment extends Entity<number>{
    frequency:string;
    ftId:Number;
    wId:Number;
    fId:Number;
}